import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Button } from "@/components/ui/button";
import { User, AlertTriangle } from 'lucide-react';

const IcNameModal = () => {
  const { isAuthenticated, hasIcName, api, updateUser } = useAuth();
  const [icName, setIcName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  if (!isAuthenticated || hasIcName) return null;

  const submit = async () => {
    const name = icName.trim();
    if (!name) {
      setError('Az IC név megadása kötelező!');
      return;
    }
    if (name.length < 3) {
      setError('Az IC név legalább 3 karakter legyen!');
      return;
    }
    if (!name.includes(' ')) {
      setError('Az IC név formátuma: Vezetéknév Keresztnév');
      return;
    }

    setLoading(true);
    setError('');
    try {
      const res = await api.put('/users/me/ic-name', { ic_name: name });
      // Refresh user data
      await updateUser({});
      window.location.reload();
    } catch (e) {
      setError(e.response?.data?.detail || 'Hiba történt a mentés során.');
    }
    setLoading(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') submit();
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/80 backdrop-blur-md" data-testid="ic-name-modal">
      <div className="bg-black/95 border border-orange-500/30 rounded-2xl p-8 max-w-md w-full mx-4 shadow-2xl">
        <div className="flex items-center justify-center w-16 h-16 bg-orange-500/20 rounded-full mx-auto mb-5">
          <User className="h-8 w-8 text-orange-400" />
        </div>

        <h2 className="text-xl font-bold text-white text-center mb-2">IC Név Megadása</h2>
        <p className="text-sm text-gray-400 text-center mb-6">
          Az oldal használatához meg kell adnod az IC (In-Character) neved. Ez a neved lesz látható a rendszerben.
        </p>

        <div className="space-y-4">
          <div>
            <input
              value={icName}
              onChange={e => { setIcName(e.target.value); setError(''); }}
              onKeyDown={handleKeyDown}
              placeholder="Vezetéknév Keresztnév"
              className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white placeholder-gray-500 outline-none focus:border-orange-500/50 text-center text-lg"
              autoFocus
              data-testid="ic-name-input"
            />
            {error && (
              <p className="text-red-400 text-xs mt-2 flex items-center gap-1 justify-center">
                <AlertTriangle className="h-3 w-3" /> {error}
              </p>
            )}
          </div>

          <Button
            onClick={submit}
            disabled={loading}
            className="w-full bg-orange-600 hover:bg-orange-700 py-3 text-base"
            data-testid="ic-name-submit"
          >
            {loading ? 'Mentés...' : 'Tovább'}
          </Button>

          <p className="text-[10px] text-gray-600 text-center">
            Formátum: Vezetéknév Keresztnév (pl. Gonzalez Marco)
          </p>
        </div>
      </div>
    </div>
  );
};

export default IcNameModal;
